module.exports = __webpack_public_path__ + "img/menu_help.32dd6648.svg";